export const dataTagPrefix = 'pimster-';
